<template>
  <Block type="accountSetting" id="changePassword">
    <common-header
      is-passport
      :show-back="!isSDK"
      :show-lang="!isSDK"
      :title="accountLanguages.changePassword"
    ></common-header>
    <form
      id="changePasswordForm"
      class="change-pwd"
      :class="$platformClass"
      v-if="!submitSuccess"
    >
      <Editor
        v-model="password"
        :class="$platformClass"
        editorType="password"
        editorClass="editor pwd-input"
        class="editor-wrapper pwd-wrapper"
        :type="$isOmni ? 'passwordEditor' : 'passportAccountEditor'"
        v-bind:placeholder="accountLanguages.originPwd"
      ></Editor>
      <Editor
        :class="$platformClass"
        v-model="newPassword"
        editorType="password"
        editorClass="editor pwd-input"
        class="editor-wrapper pwd-wrapper"
        :type="$isOmni ? 'passwordEditor' : 'passportAccountEditor'"
        v-bind:placeholder="accountLanguages.newPwd"
      ></Editor>
      <Editor
        v-model="reNewPwd"
        :class="$platformClass"
        editorType="password"
        editorClass="editor pwd-input"
        class="editor-wrapper pwd-wrapper"
        :type="$isOmni ? 'passwordEditor' : 'passportAccountEditor'"
        v-bind:placeholder="accountLanguages.repeatPassword"
      ></Editor>
      <a class="work-jump-link" @click="jumpToFeedback">
        {{ accountLanguages.contactService }}
      </a>
      <!-- <Agreements v-on:changeAgreeTerms="selectTerm"></Agreements> -->
      <Block
        tagName="label"
        type="editorWrapper"
        class="agree-wrapper change-pwd"
        :class="$platformClass"
      >
        <Button
          class="btn account-setting-submit"
          :type="$isOmni ? 'lightfill' : 'fillLight'"
          @click="changePwd"
        >
          <Icon type="commonBtnLeft"></Icon>
          <Icon type="commonBtnRight"></Icon>
          {{ accountLanguages.submit }}
        </Button>
      </Block>
    </form>
    <SubmitSuccessTips
      v-if="submitSuccess"
      :tips="accountLanguages.changePwdSuccess"
    ></SubmitSuccessTips>
    <label class="agree-wrapper email-send-btn" :class="$platformClass">
      <Button
        v-if="submitSuccess"
        data-asyncbtn
        class="btn account-setting-submit"
        :type="$isOmni ? 'lightfill' : 'fillLight'"
        @click="reChange"
      >
        <Icon type="commonBtnLeft"></Icon>
        <Icon type="commonBtnRight"></Icon>
        {{ accountLanguages.modify }}
      </Button>
    </label>
    <transition name="fade">
      <Dialog v-show="showDialog"></Dialog>
    </transition>
    <transition name="fade">
      <Tost v-show="showTost"></Tost>
    </transition>
    <PopupWindow
      @onCancel="showPopup = false"
      @onConfirm="showPopup = false"
      type="tips"
      v-if="showPopup"
      :languages="accountLanguages"
      :content="errTips"
    ></PopupWindow>
  </Block>
</template>
<script>
import { CHANGE_PWD } from '../../store/passport/accountSetting';
import AccountSettingMixins from '../../mixins/AccountSetting';
import commonHeader from '@/resource/components/support/header';
import globalConfig from '../../utiles/globalConfig';
import bridge from '../../utiles/bridge';
import { FEEKBACK_URL } from '../../utiles';
import { getGlobalGetGotoLink } from '@utiles/globalGetLink';
const OPEN_BROSWER_METHOD = 'openBrowser';
const mainHost = globalConfig.getMainHost();
// import Agreements from "../../components/passport/Agreements";
export default {
  data() {
    return {
      password: '',
      newPassword: '',
      reNewPwd: '',
      terms: true,
      workLink:
        '//' +
        window.location.hostname +
        '/platform/support.html' +
        window.location.search +
        '#/createWork',
      isSDK: false
    };
  },
  components: { commonHeader },
  mixins: [AccountSettingMixins],
  // components: { Agreements },
  methods: {
    jumpToFeedback() {
      bridge.callSdkMethod(OPEN_BROSWER_METHOD, {
        url:
          globalConfig.getHrefParam('websdk') === '1'
            ? getGlobalGetGotoLink({
                link: `https://gabres.${mainHost}/platform/webSupport.html`
              })
            : getGlobalGetGotoLink({ link: FEEKBACK_URL }),
        loginDir: 1,
        appendParams: 1
      });
    },
    changePwd() {
      this.$store
        .dispatch(CHANGE_PWD, {
          password: this.password,
          newPassword: this.newPassword,
          reNewPwd: this.reNewPwd,
          terms: this.terms,
          appLanguage: this.accountLang,
          language: this.accountLang,
          notNeedInitLanguage: true
        })
        .then(success => {
          if (success) {
            this.password = '';
            this.newPassword = '';
            this.reNewPwd = '';
            this.terms = true;
            this.submitSuccess = true;
          }
        })
        .catch(err => {
          this.showErrorTips(err.message);
        });
    }
  },
  created() {
    this.selectTerm(true);
    let hasSdkToken = !!globalConfig.getHrefParam('sdkToken');
    let isWeb = +globalConfig.getHrefParam('web') === 1;
    let isH5 = +globalConfig.getHrefParam('h5') === 1;
    this.isSDK = hasSdkToken || (isWeb && isH5);
  }
};
</script>
